/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { useHistory } from "react-router-dom";

//context
import { useCSRValue, useSelectedStoreValue } from "../context";
//custome library
import { FOR_USER_ID, FOR_USER_SESSION } from "../constants/common";
import { SHOP_ON_BEHALF } from "../constants/routes";
import { sessionStorageHelper } from "../helpers/storageHelper";
import { SHOP_AS_USER_ACTION } from "../constants/actions";

export const useShopOnBehalf = () => {
  const history = useHistory();
  const { selectedStore } = useSelectedStoreValue();
  const { csr, dispatch } = useCSRValue();

  /**
   * Execute shop on behalf of.
   * @param user the selected customer
   * @param path the path of the store. e.g. /cart
   */
  const shopOnBehalf = (user: any, path?: string) => {
    let storeUrl = selectedStore.headlessStoreContextRoot;
    const _address = { ...user.address };
    const _selectedUser = { ...user, userId: user.id };
    delete _selectedUser.address;
    const cuser = Object.assign(
      {},
      { ...csr },
      { details: { ..._selectedUser, ..._address } },
      { [FOR_USER_ID]: _selectedUser.id }
    );
    delete cuser.roles;
    delete cuser.storeList;

    const storeName = selectedStore.identifier;
    const storePath = storeUrl.startsWith("/") ? storeUrl.substr(1) : storeUrl;
    const storageKey = `HCS${storePath}-${storeName}-${FOR_USER_SESSION}`;
    if (path) {
      storeUrl = storeUrl + path;
    }
    storeUrl = storeUrl + `?storeId=${selectedStore.id}`;

    const location = {
      pathname: SHOP_ON_BEHALF,
      state: {
        storeUrl,
        storageKey,
      },
    };
    sessionStorageHelper.setForUserSession(storageKey, cuser);
    dispatch({
      type: SHOP_AS_USER_ACTION,
      payload: user,
    });
    history.push(location);
  };

  return {
    shopOnBehalf,
  };
};
